/** Category ids match `subjectGroups.*` in locale files. */
export const SUBJECT_GROUP_ORDER = [
  "law",
  "economics",
  "finance",
  "psychology",
  "it",
  "cybersecurity",
  "marketing",
  "scientific_research",
  "nutritionist",
  "architecture",
  "esports",
  "ai",
  "media_production",
  "online_sales",
  "digital_product_design",
];

export const SUBJECTS_BY_GROUP = {
  law: [
    "civil_law",
    "criminal_law",
    "corporate_law",
    "family_law",
    "labor_law",
    "tax_law",
    "intellectual_property_law",
    "immigration_law",
    "real_estate_law",
    "contract_law",
    "international_law",
    "administrative_law",
    "legal_consulting",
    "document_drafting",
    "startup_law",
    "online_business_law",
    "digital_rights_law",
    "gdpr_compliance",
    "consumer_protection_law",
    "media_law",
    "cryptocurrency_law",
    "legal_translation",
  ],
  economics: [
    "microeconomics",
    "macroeconomics",
    "econometrics",
    "economic_policy",
    "international_economics",
    "behavioral_economics",
    "public_finance_eco",
    "institutional_economics",
    "crypto_economics",
    "defi_economics",
    "token_economics",
    "startup_economics",
    "strategic_management",
    "trade_economics",
    "business_planning",
  ],
  finance: [
    "financial_planning",
    "investments",
    "financial_modeling",
    "accounting",
    "taxation",
    "stock_market",
    "crypto_trading",
    "forex_trading",
    "personal_finance",
    "corporate_finance",
    "banking",
    "insurance",
    "auditing",
    "budgeting",
    "portfolio_management",
    "defi_finance",
    "nft_finance",
    "options_trading",
    "passive_income",
    "financial_literacy",
    "risk_management_finance",
    "trading_psychology",
    "futures_trading",
    "p2e_gaming_finance",
  ],
  psychology: [
    "general_psychology",
    "psychotherapy",
    "cbt",
    "family_therapy",
    "mindfulness",
    "stress_management",
    "emotional_intelligence",
    "child_psychology",
    "positive_psychology",
    "anxiety_coaching",
    "adhd_coaching",
    "grief_support",
    "online_therapy_support",
    "self_development",
  ],
  it: [
    "python",
    "javascript",
    "java",
    "cpp",
    "web_development",
    "mobile_development",
    "data_science",
    "devops",
    "databases",
    "game_development",
    "blockchain",
    "no_code",
    "networking",
    "frontend_it",
    "backend_it",
    "qa_testing",
    "react_js",
    "node_js",
    "typescript",
    "php",
    "swift",
    "kotlin",
    "flutter",
    "rust_lang",
    "sql_databases",
    "cloud_computing",
    "api_development",
    "docker_kubernetes",
    "ai_integration",
    "wordpress",
    "automation_scripts",
    "excel_vba",
    "telegram_bots",
    "web3_development",
  ],
  cybersecurity: [
    "network_security",
    "ethical_hacking",
    "web_security",
    "malware_analysis",
    "cryptography_security",
    "security_audit",
    "incident_response",
    "penetration_testing",
    "cloud_security",
    "soc_operations",
    "osint",
    "bug_bounty",
    "social_engineering",
    "password_security",
    "vpn_privacy",
    "iot_security",
    "mobile_security",
    "cyber_hygiene",
    "digital_forensics",
    "phishing_protection",
  ],
  marketing: [
    "smm",
    "seo",
    "content_marketing",
    "digital_marketing",
    "email_marketing",
    "google_ads",
    "targeted_ads",
    "copywriting_marketing",
    "pr_communications",
    "brand_strategy",
    "web_analytics",
    "youtube_promotion",
    "affiliate_marketing",
    "community_building",
    "funnel_building",
    "personal_branding_marketing",
    "b2b_marketing",
    "viral_marketing",
    "podcast_marketing",
    "local_seo",
    "social_media_promotion",
  ],
  scientific_research: [
    "academic_writing",
    "literature_review",
    "phd_support",
    "scientific_paper_writing",
    "grant_writing",
    "data_collection",
    "thesis_writing",
    "dissertation_support",
    "citation_management",
    "scientific_translation",
    "meta_analysis",
    "systematic_review",
    "student_research_support",
    "survey_design",
  ],
  nutritionist: [
    "sports_nutrition",
    "weight_management",
    "therapeutic_nutrition",
    "vegan_nutrition",
    "child_nutrition",
    "meal_planning",
    "supplements_consulting",
    "eating_disorder_support",
    "clinical_nutrition",
    "gut_health",
    "hormone_nutrition",
    "detox_programs",
    "intermittent_fasting",
    "micronutrients",
    "plant_based_nutrition",
    "diabetic_nutrition",
  ],
  architecture: [
    "urban_planning",
    "interior_design_arch",
    "landscape_architecture",
    "sustainable_design",
    "architectural_visualization",
    "bim_technology",
    "residential_design",
    "commercial_architecture",
    "historical_preservation",
    "architectural_drawing",
    "freehand_sketching",
    "architectural_sketching",
    "autocad",
    "revit",
    "sketchup",
    "rhino_3d",
    "3d_modeling_arch",
    "rendering_arch",
    "architectural_portfolio",
    "student_project_review",
    "urban_sketching",
    "watercolor_arch",
    "design_concept",
    "construction_documentation",
    "technical_drawing",
    "blender_arch",
    "parametric_design",
    "arch_exam_prep",
  ],
  esports: [
    "esports_strategy",
    "streaming_coaching",
    "esports_team_management",
    "esports_analytics",
    "speedrunning",
    "esports_casting",
    "gaming_setup_advice",
    "twitch_growth",
    "game_mechanics_analysis",
    "dota2_coaching",
    "csgo_valorant_coaching",
    "lol_coaching",
    "mobile_esports_coaching",
    "fortnite_coaching",
    "pubg_coaching",
    "apex_coaching",
    "overwatch_coaching",
    "minecraft_coaching",
    "chess_online_coaching",
  ],
  ai: [
    "llm_prompting",
    "ai_tools_training",
    "nlp_ai",
    "ai_product_development",
    "data_science_ai",
    "ai_automation",
    "generative_ai",
    "chatgpt_prompting",
    "midjourney_training",
    "stable_diffusion",
    "ai_writing_tools",
    "ai_business_automation",
    "ai_content_creation",
    "ai_research_tools",
    "ai_marketing_tools",
    "ai_image_generation",
    "ai_video_tools",
    "ai_for_business",
  ],
  media_production: [
    "video_production",
    "podcast_production",
    "youtube_content",
    "film_directing",
    "video_editing_media",
    "sound_design",
    "broadcast_production",
    "social_media_video",
    "animation_production",
    "content_creation_strategy",
    "tiktok_production",
    "instagram_reels",
    "youtube_channel_setup",
    "thumbnail_design",
    "video_scriptwriting",
    "short_form_content",
    "travel_content",
    "educational_video",
    "viral_video_strategy",
    "reels_editing",
    "color_grading",
    "drone_videography",
  ],
  online_sales: [
    "ecommerce",
    "dropshipping",
    "social_commerce",
    "online_store_setup",
    "marketplace_strategy",
    "sales_funnels",
    "prom_rozetka_selling",
    "wholesale_online",
    "digital_products_sales",
    "online_pricing_strategy",
    "customer_acquisition",
    "reselling",
    "product_photography",
  ],
  digital_product_design: [
    "ui_ux_design",
    "product_design_digital",
    "web_design_digital",
    "motion_design_digital",
    "design_systems",
    "prototyping",
    "user_research_design",
    "figma_training",
    "graphic_design_digital",
    "brand_identity",
    "logo_design",
    "illustration",
    "icon_design",
    "social_media_design",
    "email_template_design",
    "app_design",
    "dashboard_design",
    "landing_page_design",
    "canva_training",
    "photoshop_training",
    "adobe_illustrator_training",
    "3d_design",
  ],
};

export const ALL_SUBJECT_KEYS = SUBJECT_GROUP_ORDER.flatMap((g) => SUBJECTS_BY_GROUP[g] || []);
